<template>
  <div class="screen-booking">
    <div class="popup-aside-plain">
      <div class="popup-takeResa" v-loading="loading">
        <div class="header-takeresa">
          <div style="text-align:center">{{ getAllInfos.restoName }}</div>
          <div style="font-weight:100; font-size:14px">
            <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
            <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
          </div>
          <div v-if="this.getSelectedMainServiceData">
            <div style="text-align:center">{{ this.getSelectedMainServiceData.name }}</div>
            <div style="text-align:center; font-weight:100; font-size:14px">{{ this.getSelectedMainServiceData.desc }}
            </div>
          </div>
          <div v-else style="text-align:center">
            L'évènement n'est plus d'actualité.
          </div>
          <div class="nav-round nav-step" v-if="!showTanks && this.getSelectedMainServiceData">
            <div v-if="formPart1.show">Etape 1/2</div>
            <div v-if="formPart2.show && !getCashInfos">Etape 2/2</div>
            <div v-if="formPart2.show && getCashInfos">Etape 2/3</div>
          </div>
        </div>
        <el-row v-if="this.getSelectedMainServiceData" :class="'content-takeresa black-inputs' + this.getClassModifier">
          <el-col :span="20" :offset="2" v-if="formPart1.show">
            <el-form ref="formPart1.data" :rules="rulesFormPart1" :model="formPart1.data" label-width="0px">
              <el-form-item>
                <el-radio-group v-model="formPart1.data.civ">
                  <el-radio-button label="M."></el-radio-button>
                  <el-radio-button label="Mme"></el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item prop="name">
                <el-input v-model="formPart1.data.name" placeholder="Nom*"></el-input>
              </el-form-item>
              <el-form-item prop="prenom">
                <el-input v-model="formPart1.data.prenom" placeholder="Prénom*"></el-input>
              </el-form-item>
              <el-form-item prop="email">
                <el-input v-model="formPart1.data.email" placeholder="e-mail*"></el-input>
              </el-form-item>
              <el-form-item prop="telPreFix" class="tel-prefix">
                <el-input v-model="formPart1.data.telPreFix" placeholder="+33"></el-input>
              </el-form-item>
              <el-form-item prop="tel" class="tel">
                <el-input v-model="formPart1.data.tel" placeholder="Téléphone*"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input v-model="formPart1.data.societe" placeholder="Société"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button :disabled="btnValiderDisabled" @click="onSubmitPart1('formPart1.data')"
                  type="submit">Valider</el-button>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="18" :offset="3" v-if="formPart2.show">
            <div v-if="this.getSelectedMainServiceData === undefined" style="text-align: center">
              Aucun service n'a été paramétré.<br />
              Merci de paramétrer au moins un service dans votre restaurant.
            </div>
            <el-form v-else ref="formPart2.data" :rules="rulesFormPart2" :model="formPart2.data" label-width="120px">
              <el-form-item>
                <calendar-nav :checkVisibility="true" />
              </el-form-item>
              <el-form-item v-loading="this.getSelectedService === undefined && !allServiceIsLock">
                <el-input-number v-if="this.getSelectedService && !allServiceIsLock" class="text-centered" size="medium"
                  :min="this.getSelectedService.nbMinByResa" :max="this.getSelectedService.nbMaxByResa"
                  v-model="formPart2.data.nbCouvert" @change="nbCouvUpdate"></el-input-number>
              </el-form-item>
              <el-form-item v-loading="loadingHours">
                <div class="popup-takeResa-dayClosed" v-if="getServicesHours === null && !complet">Fermé</div>
                <div class="popup-takeResa-dayClosed" v-if="complet">Complet</div>
                <div class="popup-takeResa-dayClosed" v-if="allServiceIsLock && !limitInterval">Service fermé</div>
                <div class="popup-takeResa-dayClosed" v-if="allServiceIsLock && limitInterval">Votre réservation est
                  trop importante pour ce créneau horaire.</div>
                <el-select v-if="getServicesHours !== null && !complet && !allServiceIsLock" class="text-centered"
                  v-model="formPart2.data.date2" value-key="id" placeholder="Choisissez une heure">
                  <el-option-group v-for="ms in getServicesHoursData" :key="ms.label" :label="ms.label"
                    v-if="ms.tab.length > 0">
                    <el-option v-for="h in ms.tab" :key="h.id" :label="h.hour" :value="h">
                    </el-option>
                  </el-option-group>
                </el-select>
                <div
                  v-if="getCashInfos && cashInfos && (!this.cashInfos.nbCouv || parseInt(this.cashInfos.nbCouv) <= parseInt(this.formPart2.data.nbCouvert))"
                  class="popup-takeResa-cash">
                  Réservation avec {{ getCashTerme }} de {{ cashInfos.value }}€ par couvert soit
                  {{ Math.round(cashInfos.value * formPart2.data.nbCouvert * 100) / 100 }} €.
                </div>
              </el-form-item>
              <el-form-item>
                <el-input v-model="formPart2.data.commentResa" :autosize="{ minRows: 3 }" type="textarea"
                  placeholder="Ajouter un commentaire"></el-input>
              </el-form-item>
              <el-form-item prop="allergen">
                <div>
                  <el-radio-group v-model="formPart2.data.allergen" @change="$refs['formPart2.data'].clearValidate()">
                    <el-radio style="white-space: normal; padding:5px 10px" :label="false">Aucune intolérance ou
                      allergie pour l’ensemble des convives</el-radio>
                    <el-radio style="white-space: normal; padding:5px 10px" :label="true">Intolérance / Allergie
                    </el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
              <el-form-item v-if="formPart2.data.allergen" prop="allergenMessage">
                <el-input v-model="formPart2.data.allergenMessage" :autosize="{ minRows: 3 }" type="textarea"
                  placeholder="Merci de renseigner les intolérances / allergies"></el-input>
              </el-form-item>
              <el-form-item v-if="getAllInfos.restoBookingMessage && getAllInfos.restoBookingMessage !== ''">
                <div class="bookingMessage">
                  <i class="el-icon-info bookingMessage-icon"></i>
                  <span class="bookingMessage-text" v-html="renderMarkdown(getAllInfos.restoBookingMessage)"></span>
                </div>
              </el-form-item>
              <div v-loading="loadingTakeResa">
                <el-form-item>
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-button class="dark" type="primary" @click="backForm">Précédent</el-button>
                    </el-col>
                    <el-col :span="12">
                      <el-button v-if="!loadingTakeResa && !complet && !allServiceIsLock"
                        :disabled="btnReserverDisabled" type="primary"
                        @click="onSubmitPart2('formPart2.data')">Réserver</el-button>
                    </el-col>
                  </el-row>
                </el-form-item>
              </div>
              <el-form-item>
                <div class="screen-booking-ml">
                  <el-collapse v-model="mlActive">
                    <el-collapse-item title="Mentions légales & RGPD" name="1">
                      <div class="screen-booking-rgpd">
                        <div>
                          Veuillez cocher les cases ci-dessous si vous acceptez que {{ getAllInfos.restoName }}
                          collecte et utilise les données personnelles que vous venez de renseigner dans ce formulaire
                          dans le but de vous informer sur ses activités et sa programmation, en accord avec notre
                          <a href="/static/download/Politique-de-Protection-des-Donnees.pdf" target="_blank">politique
                            de protection des données</a>
                        </div>
                        <div>par :</div>
                        <div class="checkboxes">
                          <el-checkbox v-model="rgpdmail">E-mail</el-checkbox>
                          <el-checkbox v-model="rgpdsms">SMS</el-checkbox>
                        </div>
                        <div><a href="/static/download/CONDITIONS-GENERALES-D-UTILISATION-RESERVATION-EN-LIGNE.pdf"
                            target="_blank">En validant ma réservation, je déclare accepter les conditions générales
                            d'utilisation du service</a></div>
                      </div>
                      <br>
                      <div>
                        Données récoltées via la société RESA.NINJA (RCS Paris 420 442 675) à des fins d'informations
                        relatives à la réservation (confirmation, annulation, demandes d'avis), relatives à l’enseigne
                        {{ getAllInfos.restoName }}. Les données récoltées pourront être croisées avec celles d’ores et
                        déjà détenues par l'enseigne {{ getAllInfos.restoName }}.
                        Conformément à la loi Informatique et Liberté du 6 Janvier 1978 et modifiée en 2004, vous
                        disposez d’un droit d’accès, de rectification et de suppression des données vous concernant.
                        Pour exercer ces droits, il vous suffit d’en faire la demande auprès du service client par
                        courrier à l’adresse suivante : RESA.NINJA - Service Marketing – 11, rue des Emeraudes - 69006
                        LYON.
                        Les données récoltées sont conservées dans les conditions de durée prévues par la norme
                        simplifiée n°48 de la CNIL.
                      </div>
                    </el-collapse-item>
                  </el-collapse>
                </div>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col class="step3" :span="18" :offset="3" v-if="showTanks && !getAllInfos.restoAutoAccept">
            <br>
            <div>Votre réservation a été soumise au restaurateur.</div>
            <br>
            <div>Une fois votre réservation validée un email de confirmation vous sera envoyé.</div>
            <br>
            <div>IMPORTANT: Si vous ne recevez pas nos emails, merci de vérifier vos spams ou l'onglet Promotions sur
              Gmail.</div>
            <br>
            <div>Bonne journée !</div>
            <br>
            <div></div>
          </el-col>
          <el-col class="step3" :span="18" :offset="3" v-else-if="showTanks && getAllInfos.restoAutoAccept">
            <br>
            <p v-if="getAllInfos.resaConfirmMessage">
              {{ getAllInfos.resaConfirmMessage }}
            </p>
            <p v-else>
              Bravo ! <br />Votre réservation est acceptée par le restaurateur.
            </p>
            <br>
            <div>Nous vous attendons donc le {{ getSelectedDay.labelDay }} {{ getSelectedDay.day }}
              {{ getSelectedDay.labelMonth }} {{ getSelectedDay.year }} à {{ formPart2.data.date2.hour }} pour
              {{ formPart2.data.nbCouvert }} couvert(s). </div>
            <br>
            <div>Bonne journée !</div>
            <br>
            <div></div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { Notification } from 'element-ui';
import uuidv4 from 'uuid/v4';
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import 'whatwg-fetch';
import router from '../router';
import { ERequestType, fetchPostHelper, fetchPutHelper } from '../tools/fetch';
import { fetchCheckout, fetchCheckoutPAuto } from '../tools/fetchHelper';
import { injectGtm } from '../tools/gtm';
import { renderMarkdown } from '../tools/markdownHelper';
import { sendResaConfirmedMessage, sendResaPreConfirmedMessage, sendResaTakedRestaurateur, sendResaToConfirmRestaurateur } from '../tools/messageSender';
import { dateToTimeStamp, formatTimeH, parseTime } from '../tools/timeTool';
import { checkPhone, validatePrefix } from '../tools/validator';
import * as resaState from './../store/types/resa-state';
import CalendarNav from './calendar/CalendarNavPicker';

export default {
  name: 'EventBooking',
  components: { CalendarNav },
  data() {
    return {
      pk: {
        type: String,
        required: true
      },
      formPart1: {
        data: {
          civ: 'M.',
          name: '',
          email: '',
          prenom: '',
          telPreFix: '+33',
          tel: '',
          societe: '',
          captcha: ''
        },
        show: true,
        cid: ''
      },
      formPart2: {
        data: {
          nbCouvert: 2,
          date1: new Date(),
          date2: '',
          room: '',
          tids: {},
          commentResa: '',
          allergen: '',
          allergenMessage: ''
        },
        show: false
      },
      rgpdmail: false,
      rgpdsms: false,
      currentClient: undefined,
      showTanks: false,
      mlActive: [],
      tabHours: {},
      rulesFormPart1: {},
      rulesFormPart2: {},
      btnReserverDisabled: false,
      btnValiderDisabled: false,
      loading: false,
      loadingTakeResa: false,
      selectedDay: null,
      complet: false,
      allServiceIsLock: false,
      limitInterval: false,
      loadingHours: false,
      cashInfos: undefined,
      currentNbCouv: 0
    }
  },
  computed: {
    // TODO: function with short uid
    ...mapGetters({
      getClosedDays: 'newServices/getClosedDays',
      getDaysIsClosed: 'newServices/getDaysIsClosed',
      getDaysIsInvisible: 'newServices/getDaysIsInvisible',
      getCompletService: 'newServices/getCompletService',
      getSelectedDay: 'calendar/getSelectedDay',
      getSelectedMainServiceData: 'newServices/getSelectedMainServiceData',
      getMainServiceDataByServiceAndDay: 'newServices/getMainServiceDataByServiceAndDay',
      getAllInfos: 'infos/getAllInfos',
      getUserType: 'newUsers/getUserType',
      getCashDaysList: 'cash/getCashDaysList',
      getCashStateForDayAndService: 'cash/getCashStateForDayAndService'
    }),
    pickerOptions: function () {
      let closedDays = this.getClosedDays(true)
      let options = {}
      options.disabledDate = function (time) {
        if (time.getTime() < (Date.now() - 3600 * 1000 * 24)) {
          return time.getTime() < (Date.now() - 3600 * 1000 * 24)
        } else {
          // hack for Monday stay first day
          let d = time.getDay()
          if (d === 0) d = 7
          // looking for closedDays
          let found = closedDays.find(function (val) {
            return val === d
          })
          return found
        }
      }
      options.firstDayOfWeek = 1
      return options
    },
    getSelectedService: function () {
      if (this.formPart2 && this.formPart2.data && this.formPart2.data.date2 && this.formPart2.data.date2.ms && this.getSelectedDay.labelDay) {
        return this.getMainServiceDataByServiceAndDay(this.formPart2.data.date2.ms, this.getSelectedDay.labelDay)
      }
      return undefined
    },
    getCashTerme: function () {
      if (this.cashInfos && this.cashInfos.type && this.cashInfos.type === 'caution') return 'empreinte bancaire'
      else if (this.cashInfos && this.cashInfos.type && this.cashInfos.type === 'prepaiement') return 'prépaiement'
      return this.cashInfos.type
    },
    getCashInfos: function () {
      let ts = dateToTimeStamp(this.getSelectedDay.day, this.getSelectedDay.month - 1, this.getSelectedDay.year)
      if (this.formPart2.data && this.formPart2.data.date2) {
        let service = this.formPart2.data.date2.ms
        this.checkExistCashDays({
          restoid: this.$router.currentRoute.params.id,
          ts: ts,
          service: service
        }).then(res => {
          let selectedServiceData = this.getSelectedService
          if (res && res !== '') {
            this.cashInfos = {
              type: res.type,
              value: res.value,
              nbCouv: res.nbCouv
            }
          } else if (selectedServiceData && selectedServiceData.cashOn) {
            this.cashInfos = {
              type: selectedServiceData.cashType,
              value: selectedServiceData.cashPrice,
              nbCouv: selectedServiceData.cashCouv
            }
          } else {
            this.cashInfos = undefined
          }
        }).catch(() => {
          this.cashInfos = undefined
        })
      }
      return true
    },
    getClassModifier: function () {
      if (this.getUserType === 'classique') {
        return ''
      }
      return `-${this.getUserType.toString()}`
    },
    getServicesHoursData: function () {
      return this.tabHours
    },
    getCouvSelected: function () {
      if (this.currentNbCouv === 0) return 2
      return parseInt(this.currentNbCouv)
    },
    async getServicesHours(e) {
      if (this.getSelectedDay !== '' && !this.getDaysIsClosed(this.getSelectedDay.weekday, true) && !this.getDaysIsInvisible(this.getSelectedDay.weekday) && this.currentNbCouv) {
        this.loadingHours = true
        this.complet = false
        let tabHSResult = null
        let dateTemp = this.getSelectedDay.date
        const result = await this.findFirstOpenServiceHours({ day: this.getSelectedDay, keepCurrent: false, passed: false, checkLock: true, checkVisibility: true }).then(async (tabHS) => {
          // get first disponnible hour
          // check if service is lock
          if (Object.entries(tabHS).length > 0) {
            let checkInterval = false
            // curent each service get tab hour
            let tempTabHS = JSON.parse(JSON.stringify(tabHS))
            // last length for match capacityinterval tab id
            for (let i = 0; i < Object.entries(tabHS).length; i++) {
              // get service s
              const serviceTabHours = Object.entries(tabHS)[i]
              const serviceLabel = serviceTabHours[0]
              const serviceDatas = serviceTabHours[1]
              // get datas
              let currentServiceDatas = this.getMainServiceDataByServiceAndDay(serviceLabel, this.getSelectedDay.labelDay)
              // if lock delete service
              if (serviceDatas.lock) {
                Vue.delete(tempTabHS, serviceLabel)
              } else if (currentServiceDatas.capacityIntervalTab && currentServiceDatas.capacityIntervalTab.length > 0) {
                checkInterval = true
                // if capacity par tranche horraire exist
                let idToRemove = []
                // get occupation by hour
                let request = {
                  uid: this.$router.currentRoute.params.id,
                  ts: dateToTimeStamp(this.getSelectedDay.day, this.getSelectedDay.month - 1, this.getSelectedDay.year)
                }
                await this.loadNbCouvByHour(request).then(res => {
                  // for each hours of service
                  serviceDatas.tab.forEach(h => {
                    let checkid = currentServiceDatas.capacityIntervalTab.find((serviceDatas) => serviceDatas.hour === h.hour).id
                    // get places avaibles
                    if (currentServiceDatas.capacityIntervalTab[checkid] && currentServiceDatas.capacityIntervalTab[checkid].capacity > 0) {
                      let couvTaked = 0
                      if (res.data[h.hour]) couvTaked = res.data[h.hour]
                      let couvCapacity = currentServiceDatas.capacityIntervalTab[checkid].capacity
                      let couvAvaible = couvCapacity - couvTaked
                      // save id to remove if complet for this hour
                      if (couvAvaible - parseInt(this.formPart2.data.nbCouvert) < 0) {
                        idToRemove.push(h.hour)
                      }
                    } else if (currentServiceDatas.capacityIntervalTab[checkid] && currentServiceDatas.capacityIntervalTab[checkid].capacity < 0) {
                      idToRemove.push(h.hour)
                    }
                  })
                })
                if (idToRemove.length >= Object.entries(tempTabHS).length) this.complet = true
                // remove id to remove
                idToRemove.forEach(hour => {
                  tempTabHS[serviceLabel].tab = tempTabHS[serviceLabel].tab.filter((h, index) => h.hour !== hour)
                })
                // remopve service if no hour avaible
                if (tempTabHS[serviceLabel].tab.length === 0) Vue.delete(tempTabHS, serviceLabel)
              }
            }
            tabHSResult = Object.assign({}, tempTabHS)
            // check if current selected hour keep existing
            if (this.getSelectedDay.date !== dateTemp) {
              this.formPart2.data.date2 = ''
            } else {
              let found = false
              Object.entries(tabHSResult).forEach(([index, hs]) => {
                hs.tab.forEach(hTest => {
                  if (hTest.hour === this.formPart2.data.date2.hour) found = true
                })
              })
              if (!found) this.formPart2.data.date2 = ''
              if (Object.entries(tabHSResult).length === 0) {
                this.loadingHours = false
                this.allServiceIsLock = true
                if (checkInterval) this.limitInterval = true
                return null
              } else {
                this.allServiceIsLock = false
                this.limitInterval = false
              }
            }
          }
          if (this.getSelectedDay.date !== dateTemp) {
            this.loadingHours = false
            return null
          } else {
            return this.getCurrentCapacity({ selectDay: this.getSelectedDay, tabHour: tabHSResult, nbCouv: parseInt(this.formPart2.data.nbCouvert) }).then((tab) => {
              if (Object.entries(tab).length > 0) {
                if (this.formPart2.data.date2 === '') this.formPart2.data.date2 = tab[Object.keys(tab)[0]].tab[0]
                else {
                  let found = false
                  Object.entries(tab).forEach(([index, hs]) => {
                    hs.tab.forEach(hTest => {
                      if (hTest.hour === this.formPart2.data.date2.hour) {
                        found = true
                        this.formPart2.data.date2 = hTest
                      }
                    })
                  })
                  if (!found) this.formPart2.data.date2 = tab[Object.keys(tab)[0]].tab[0]
                }
                this.tabHours = tab
                this.complet = false
                this.loadingHours = false
                return tab
              } else {
                this.loadingHours = false
                this.complet = true
                return null
              }
            })
          }
          // check if service is complet
        })
        return result
      } else {
        this.loadingHours = false
        this.complet = true
        return null
      }
    }
  },
  methods: {
    renderMarkdown,
    ...mapActions({
      findFirstOpenServiceHours: 'newServices/findFirstOpenServiceHours',
      getCurrentCapacity: 'newServices/getCurrentCapacity',
      checkClientExisting: 'newClients/checkClientExisting',
      updateClient: 'newClients/updateClient',
      bookingClientProcess: 'newClients/bookingClientProcess',
      checkExistCashDays: 'cash/checkExistCashDays',
      loadNbCouvByHour: 'newReservations/loadNbCouvByHour'
    }),
    submit: function () { },
    nbCouvUpdate: function (val) {
      this.currentNbCouv = val
    },
    checkStatus: function (response) {
      if (response.status >= 200 && response.status < 300) {
        return response
      } else {
        var error = new Error(response.statusText)
        error.response = response
        throw error
      }
    },
    parseJSON: function (response) {
      return response.json()
    },
    onSubmitPart1: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.btnValiderDisabled = true
          this.loadingTakeResa = true
          this.loading = true
          // check if client exist
          this.bookingClientProcess({
            restoid: this.$router.currentRoute.params.id,
            cid: this.formPart1.cid,
            clientPreFix: '',
            name: this.formPart1.data.name,
            prenom: this.formPart1.data.prenom,
            telPreFix: this.formPart1.data.telPreFix,
            tel: this.formPart1.data.tel,
            email: this.formPart1.data.email,
            civ: this.formPart1.data.civ,
            societe: this.formPart1.data.societe
          }).then(result => {
            // booking process end get client
            this.currentClient = result

            // update rgpd data for front if data is undefined
            if (this.currentClient.rgpdmail !== undefined) this.rgpdmail = this.currentClient.rgpdmail
            if (this.currentClient.rgpdsms !== undefined) this.rgpdsms = this.currentClient.rgpdsms

            this.btnValiderDisabled = false
            this.loadingTakeResa = false
          })

          // switch to the next part of booking
          this.switchForm()
        } else {
          this.btnValiderDisabled = false
          this.loadingTakeResa = false
          return false
        }
        this.loading = false
      })
    },
    async onSubmitPart2(formName) {
      this.btnReserverDisabled = true
      this.loading = true
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // update client rgpd informations
          this.currentClient.rgpdmail = this.rgpdmail
          this.currentClient.rgpdsms = this.rgpdsms
          this.updateClient(this.currentClient)

          if (this.cashInfos && (!this.cashInfos.nbCouv || parseInt(this.cashInfos.nbCouv) <= parseInt(this.formPart2.data.nbCouvert))) {
            let source = (router.currentRoute.name === 'site web') ? 'web' : router.currentRoute.name
            let newCashResa = {
              restoid: this.$router.currentRoute.params.id,
              ts: dateToTimeStamp(this.getSelectedDay.day, this.getSelectedDay.month - 1, this.getSelectedDay.year),
              service: this.formPart2.data.date2.ms,
              type: this.cashInfos.type,
              couverts: this.formPart2.data.nbCouvert,
              amount: this.cashInfos.value,
              total: Math.round((parseFloat(this.formPart2.data.nbCouvert) * parseFloat(this.cashInfos.value)) * 100) / 100,
              hour: this.formPart2.data.date2.hour,
              cid: this.currentClient.cid,
              date: this.getSelectedDay,
              comment: this.formPart2.data.commentResa,
              allergen: this.formPart2.data.allergen,
              allergenMessage: this.formPart2.data.allergenMessage,
              stripeid: '',
              setupid: '',
              paidid: '',
              source: source,
              taked: false
            }
            // create cashresa
            fetchPostHelper(ERequestType.CASHRESAS.CREATE, newCashResa).then((resCR) => {
              if (this.getAllInfos.restoAutoAcceptPrepaiement && this.cashInfos.type === 'prepaiement') {
                // initiate checkout process
                fetchCheckoutPAuto(
                  this.$router.currentRoute.params.id,
                  this.getAllInfos.restoName,
                  this.cashInfos.type,
                  this.cashInfos.value * 100,
                  this.formPart2.data.nbCouvert,
                  source,
                  resCR.data.id,
                  this.currentClient.email,
                  `${this.currentClient.name} ${this.currentClient.prenom}`,
                  `${this.getAllInfos.restoName}-${this.formPart1.data.civ} ${this.formPart1.data.name} ${this.formPart1.data.prenom} - tel : ${this.formPart1.data.tel} - email : ${this.formPart1.data.email} - service : ${this.formPart2.data.date2.ms} - le : ${this.getSelectedDay.labelDay} ${this.getSelectedDay.label} ${this.getSelectedDay.month} ${this.getSelectedDay.year} à ${this.formPart2.data.date2.hour}`
                ).then(resCO => {
                  // update ids for cashresa
                  newCashResa.stripeid = resCO.session.id
                  newCashResa.paidid = resCO.session.payment_intent
                  newCashResa.id = resCR.data.id

                  // update cashresa ids datas
                  fetchPutHelper(ERequestType.CASHRESAS.UPDATE, newCashResa).then((updatedCR) => {
                    // launch setup intent
                    this.loadStripeCheckout(() => {
                      try {
                        let stripe = window.Stripe(process.env.PK_STRIPE)
                        stripe.redirectToCheckout({
                          // Make the id field from the Checkout Session creation API response
                          // available to this file, so you can provide it as parameter here
                          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                          sessionId: resCO.session.id
                        }).then(function (result) {
                          // If `redirectToCheckout` fails due to a browser or network
                          // error, display the localized error message to your customer
                          // using `result.error.message`.
                        })
                      } catch (e) {
                        console.error(e)
                        this.$emit('error', e)
                      } finally {
                        this.$emit('loading', false)
                      }
                    })
                  })
                })
              } else {
                // initiate checkout process
                fetchCheckout(
                  this.$router.currentRoute.params.id,
                  this.getAllInfos.restoName,
                  this.cashInfos.type,
                  this.cashInfos.value * 100,
                  this.formPart2.data.nbCouvert,
                  source,
                  resCR.data.id,
                  this.currentClient.email,
                  `${this.currentClient.name} ${this.currentClient.prenom}`
                ).then(resCO => {
                  // update ids for cashresa
                  newCashResa.stripeid = resCO.session.id
                  newCashResa.setupid = resCO.session.setup_intent
                  newCashResa.id = resCR.data.id
                  // update cashresa ids datas
                  fetchPutHelper(ERequestType.CASHRESAS.UPDATE, newCashResa).then((updatedCR) => {
                    // launch setup intent
                    this.loadStripeCheckout(() => {
                      try {
                        let stripe = window.Stripe(process.env.PK_STRIPE)
                        stripe.redirectToCheckout({
                          // Make the id field from the Checkout Session creation API response
                          // available to this file, so you can provide it as parameter here
                          // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                          sessionId: resCO.session.id
                        }).then(function (result) {
                          // If `redirectToCheckout` fails due to a browser or network
                          // error, display the localized error message to your customer
                          // using `result.error.message`.
                        })
                      } catch (e) {
                        console.error(e)
                        this.$emit('error', e)
                      } finally {
                        this.$emit('loading', false)
                      }
                    })
                  })
                })
              }
            })
          } else {
            let stateResa = resaState.TO_CONFIRM
            if (this.getAllInfos.restoAutoAccept) stateResa = resaState.CONFIRMED
            // format data
            let resaData = {
              id: uuidv4(),
              ts: dateToTimeStamp(this.getSelectedDay.day, this.getSelectedDay.month - 1, this.getSelectedDay.year),
              restoid: router.currentRoute.params.id,
              cid: this.currentClient.cid,
              nbCouvert: this.formPart2.data.nbCouvert,
              hour: this.formPart2.data.date2.hour,
              dateResa: this.getSelectedDay,
              dateBooking: new Date(),
              room: '',
              tids: [],
              source: router.currentRoute.name,
              ms: this.formPart2.data.date2.ms,
              subs: this.formPart2.data.date2.subs,
              commentResa: this.formPart2.data.commentResa,
              allergen: this.formPart2.data.allergen,
              allergenMessage: this.formPart2.data.allergenMessage,
              modifyBy: 'CLIENT',
              state: stateResa
            }
            // call cloud function takeResa
            await fetchPostHelper(ERequestType.RESAS.CREATE, resaData).then(resaTaked => {
              this.btnReserverDisabled = false
              this.loading = false
              Notification.success({
                title: 'Demande envoyée',
                message: 'Votre demande de réservation est envoyée au restaurateur. ',
                position: 'bottom-right'
              })

              let hourFormatted = formatTimeH(parseTime(this.formPart2.data.date2.hour))
              // for client
              if (this.getAllInfos.restoAutoAccept) {
                // get modify link
                let host = `http://${window.location.hostname}`
                let ts = dateToTimeStamp(resaData.dateResa.day, resaData.dateResa.month - 1, resaData.dateResa.year)
                let link = `${host}/change/${resaData.restoid.toString()}/${ts.toString()}/${resaData.id.toString()}`

                sendResaConfirmedMessage({
                  clientName: `${this.currentClient.name} ${this.currentClient.prenom}`,
                  clientEmail: this.currentClient.email,
                  restoName: this.getAllInfos.restoName,
                  restoEmail: this.getAllInfos.restoMail,
                  dateResa: `${resaTaked.data.dateResa.labelDay} ${resaTaked.data.dateResa.day.toString()} ${resaTaked.data.dateResa.labelMonth} ${resaTaked.data.dateResa.year.toString()}`,
                  hourResa: hourFormatted,
                  message: this.getAllInfos.resaFirstMessage,
                  nbCouverts: resaTaked.data.nbCouvert,
                  adresse: this.getAllInfos.restoAdresse,
                  tel: this.getAllInfos.restoTel,
                  url: link,
                  type: resaTaked.data.type,
                  total: resaTaked.data.total,
                  restoid: this.getAllInfos.restoid,
                  discount: null,
                  sendSms: !!this.getAllInfos.clientSmsSended,
                  clientTel: this.currentClient.tel,
                  clientTelPreFix: this.currentClient.telPreFix
                })
              } else {
                sendResaPreConfirmedMessage({
                  clientName: `${this.currentClient.name} ${this.currentClient.prenom}`,
                  clientEmail: this.currentClient.email,
                  restoName: this.getAllInfos.restoName,
                  restoEmail: this.getAllInfos.restoMail,
                  dateResa: `${resaTaked.data.dateResa.labelDay} ${resaTaked.data.dateResa.day.toString()} ${resaTaked.data.dateResa.labelMonth} ${resaTaked.data.dateResa.year.toString()}`,
                  hourResa: hourFormatted,
                  message: this.getAllInfos.resaFirstMessage,
                  nbCouverts: resaTaked.data.nbCouvert,
                  adresse: this.getAllInfos.restoAdresse,
                  tel: this.getAllInfos.restoTel,
                  type: resaTaked.data.type,
                  total: resaTaked.data.total,
                  discount: null,
                  sendSms: !!this.getAllInfos.clientSmsSended,
                  clientTel: this.currentClient.tel,
                  clientTelPreFix: this.currentClient.telPreFix,
                  restoid: this.getAllInfos.restoid
                })
              }
              // for restaurateur
              if (this.getAllInfos.restoMailSended !== undefined && this.getAllInfos.restoMailSended && !this.getAllInfos.restoAutoAccept) {
                sendResaToConfirmRestaurateur({
                  clientName: `${this.currentClient.name} ${this.currentClient.prenom}`,
                  clientEmail: this.currentClient.email,
                  clientTel: this.currentClient.tel,
                  restoName: this.getAllInfos.restoName,
                  restoEmail: this.getAllInfos.restoMail,
                  dateResa: `${resaTaked.data.dateResa.labelDay} ${resaTaked.data.dateResa.day.toString()} ${resaTaked.data.dateResa.labelMonth} ${resaTaked.data.dateResa.year.toString()}`,
                  hourResa: hourFormatted,
                  message: this.getAllInfos.resaFirstMessage,
                  nbCouverts: resaTaked.data.nbCouvert,
                  adresse: this.getAllInfos.restoAdresse,
                  tel: this.getAllInfos.restoTel,
                  source: resaTaked.data.source,
                  discount: null
                })
              } else if (this.getAllInfos.restoMailSended !== undefined && this.getAllInfos.restoMailSended && this.getAllInfos.restoAutoAccept) {
                sendResaTakedRestaurateur({
                  clientName: `${this.currentClient.name} ${this.currentClient.prenom}`,
                  clientEmail: this.currentClient.email,
                  restoName: this.getAllInfos.restoName,
                  restoEmail: this.getAllInfos.restoMail,
                  dateResa: `${resaTaked.data.dateResa.labelDay} ${resaTaked.data.dateResa.day.toString()} ${resaTaked.data.dateResa.labelMonth} ${resaTaked.data.dateResa.year.toString()}`,
                  hourResa: hourFormatted,
                  message: this.getAllInfos.resaFirstMessage,
                  nbCouverts: resaTaked.data.nbCouvert,
                  adresse: this.getAllInfos.restoAdresse,
                  tel: this.getAllInfos.restoTel,
                  source: resaTaked.data.source,
                  discount: null
                })
              }

              // re-init forms
              this.switchForm(true)
            }).catch(err => {
              console.error(err)
              Notification.error({
                title: 'Error',
                message: err.message,
                position: 'bottom-right'
              })
            })
          }
        } else {
          this.btnReserverDisabled = false
          this.loading = false
          return false
        }
      })
    },
    loadStripeCheckout: (callback) => {
      let e = document.createElement('script')
      e.src = 'https://js.stripe.com/v3/'
      e.type = 'text/javascript'
      document.getElementsByTagName('head')[0].appendChild(e)
      e.addEventListener('load', callback)
    },
    backForm: function () {
      if (this.formPart1.show) {
        this.formPart1.show = false
        this.formPart2.show = true
      } else {
        this.formPart2.show = false
        this.formPart1.show = true
      }
    },
    switchForm: function (end = false) {
      window.scrollTo(0, 0)
      if (end) {
        this.formPart2.show = false
        this.formPart1.show = false
        this.showTanks = true
      } else if (this.formPart1.show) {
        this.formPart1.show = false
        this.formPart2.show = true
        this.showTanks = false
      } else {
        this.formPart2.show = false
        this.formPart1.show = true
        this.showTanks = false
      }
      if (this.showTanks) {
        window.top.postMessage('complete', '*')
      }
    }
  },
  watch: {
    'getAllInfos.googleTagManagerId': {
      immediate: true,
      handler(id) {
        if (id) injectGtm(id)
      }
    }
  },
  mounted: function () {
    if (this.$route.query.bgcolor && this.$route.query.bgcolor !== '') {
      document.querySelector('body').style.backgroundColor = `#${this.$route.query.bgcolor}`
      document.querySelector('.popup-aside-plain').style.backgroundColor = `#${this.$route.query.bgcolor}`
      document.querySelector('.popup-takeResa').style.backgroundColor = `#${this.$route.query.bgcolor}`
    }
    if (this.$route.query.txtheadercolor && this.$route.query.txtheadercolor !== '') {
      document.querySelector('.content-takeresa').style.color = `#${this.$route.query.txtheadercolor}`
      document.querySelector('.header-takeresa').style.color = `#${this.$route.query.txtheadercolor}`
    }
    if (this.$route.query.txtselectradio && this.$route.query.txtselectradio !== '') {
      document.querySelector('.el-radio-button__orig-radio:checked+.el-radio-button__inner').style.color = `#${this.$route.query.txtselectradio}`
    }
    var r = document.querySelector(':root')
    if (this.$route.query.darkmaincolor && this.$route.query.darkmaincolor !== '') {
      r.style.setProperty('--dark__main_color', `#${this.$route.query.darkmaincolor}`)
    }
    if (this.$route.query.darkmaincolorlight && this.$route.query.darkmaincolorlight !== '') {
      r.style.setProperty('--dark__main_color-light', `#${this.$route.query.darkmaincolorlight}`)
    }
    if (this.$route.query.darkmaincolorlow && this.$route.query.darkmaincolorlow !== '') {
      r.style.setProperty('--dark__main_color-low', `#${this.$route.query.darkmaincolorlow}`)
    }
    if (this.$route.query.darkmaincolormid && this.$route.query.darkmaincolormid !== '') {
      r.style.setProperty('--dark__main_color-mid', `#${this.$route.query.darkmaincolormid}`)
    }
    if (this.$route.query.textfield && this.$route.query.textfield !== '') {
      r.style.setProperty('--text_color_white', `#${this.$route.query.textfield}`)
    }
    if (this.$route.query.textplaceholder && this.$route.query.textplaceholder !== '') {
      r.style.setProperty('--text_color_placeholder_grey', `#${this.$route.query.textplaceholder}`)
    }
    if (this.$route.query.colorazure && this.$route.query.colorazure !== '') {
      r.style.setProperty('--color_blue_azure', `#${this.$route.query.colorazure}`)
    }
  },
  created: function () {
    // push message to form
    if (Object.entries(router.currentRoute.query).length > 0 && router.currentRoute.query.comment) {
      this.formPart2.data.commentResa = router.currentRoute.query.comment
    }
    this.currentNbCouv = 2
    // set rules for form 1
    this.rulesFormPart1 = {
      email: [
        { required: true, message: 'Merci de rentrer une adresse e-mail', trigger: 'blur' },
        { type: 'email', message: 'Merci de rentrer une adresse e-mail valide', trigger: 'blur' }
      ],
      name: [
        { required: true, message: 'Merci de rentrer un nom', trigger: 'blur' }
      ],
      prenom: [
        { required: true, message: 'Merci de rentrer un prénom', trigger: 'blur' }
      ],
      tel: [
        { validator: checkPhone, trigger: 'blur' },
        { required: true, message: 'Merci de rentrer un téléphone', trigger: 'blur' }
      ],
      telPreFix: [
        { validator: (rule, value, callback) => validatePrefix(rule, value, callback, this.formPart1.data.tel), trigger: 'blur' },
        { required: true, message: 'Invalide', trigger: 'blur' }
      ]
    }
    this.rulesFormPart2 = {
      allergen: [
        { required: true, message: 'Merci de renseigner si vous avez des intolérances / allergies', trigger: 'change' }
      ],
      allergenMessage: [
        { required: true, message: 'Veuillez renseigner les intolérances / allergies', trigger: 'blur' }
      ]
    }
    // hide version for booking screen
    if (this.$router.currentRoute.name === 'facebook' ||
      this.$router.currentRoute.name === 'site web' ||
      this.$router.currentRoute.name === 'google' ||
      this.$router.currentRoute.name === 'yelp' ||
      this.$router.currentRoute.name === 'lyonresto' ||
      this.$router.currentRoute.name === 'instagram' ||
      this.$router.currentRoute.name === 'tripadvisor') {
      if (this.$parent.$refs.version !== undefined) this.$parent.$refs.version.className += ' hide-version'
    }
  }
}
</script>

<style lang="scss">
@use "../styles/vars";
@use "../styles/mixins";

@use "../styles/components/elements/popup";
@use "../styles/components/elements/blackInputs";
@use "../styles/components/elements/buttons";
@use "../styles/components/elements/nav";
@use "../styles/components/elements/notif";
@use "../styles/components/elements/selector";
@use "../styles/components/layout/screens";
@use "../styles/components/layout/calendar";

a {
  color: var(--color_blue_azure);
}

#app {
  overflow-y: auto;
}

.hide-version {
  display: none;
}

.tel {
  width: 75%;
  margin-left: 1%;
  display: inline-block;

  &-prefix {
    width: 22%;
    display: inline-block;

    input {
      text-align: right;
    }
  }
}

.el-collapse {
  border: none;

  &-item {
    &__header {
      color: var(--color_white);
      background-color: inherit;
      border: none;
      text-align: center;
      display: inline-block;

      i {
        margin-left: 20px;
      }
    }

    &__wrap {
      background-color: inherit;
      border: none;
    }

    &__content {
      color: var(--color_white);
      font-weight: 100;
      line-height: 14px;
      font-size: 13px;
      margin-bottom: 3px;
    }
  }
}

.el-radio,
.el-radio__inner,
.el-radio__input {
  display: flex;
}

.bookingMessage {
  white-space: pre-line;
  line-height: 18px;
  display: flex;
  border: 1px solid;
  border-radius: 25px;
  padding: 10px;

  &-icon {
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  &-text {
    display: inline-block;
  }
}
</style>
